import React from 'react';

import { Box, Text } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';

type PendingInvitationsTableHeaderProps = {
  isSortDate: boolean;
  isSortDateAsc: boolean;
  onSortToggle: (isAscending: boolean) => void;
  showActionColumn?: boolean;
};

export const PendingInvitationsTableHeader: React.FC<
  PendingInvitationsTableHeaderProps
> = ({ isSortDate, isSortDateAsc, onSortToggle, showActionColumn = true }) => {
  return (
    <Box
      flexDirection='row'
      backgroundColor='grey01'
      paddingVertical='s'
      paddingHorizontal='m'
      borderBottomWidth={1}
      borderBottomColor='grey02'>
      <Box flex={2.66} flexDirection='row' alignItems='center'>
        <Text variant='webBodySecondary' color='grey04'>
          Email or Name
        </Text>
      </Box>
      <Box flex={2.4} alignItems='flex-start' justifyContent='center'>
        <Text variant='webBodySecondary' color='grey04' ml='m'>
          Invited By
        </Text>
      </Box>
      <Box flex={1.64} flexDirection='row' alignItems='center'>
        <Text variant='webBodySecondary' color='grey04' ml='m'>
          Date Sent
        </Text>
        <Icon
          marginLeft='xs'
          variant='xxs'
          name='ArrowUpNarrow'
          color={isSortDate && isSortDateAsc ? 'greenSecondary' : 'grey04'}
          style={{ marginRight: -3 }}
          onPress={() => onSortToggle(true)}
        />
        <Icon
          variant='xxs'
          name='ArrowDownNarrow'
          color={isSortDate && !isSortDateAsc ? 'greenSecondary' : 'grey04'}
          style={{ marginLeft: -3 }}
          onPress={() => onSortToggle(false)}
        />
      </Box>
      <Box flex={1.64} alignItems='flex-start' justifyContent='center'>
        <Text variant='webBodySecondary' color='grey04' ml='m'>
          Expiration Date
        </Text>
      </Box>
      <Box flex={1.2} alignItems='flex-start' justifyContent='center'>
        <Text variant='webBodySecondary' color='grey04' ml='m'>
          Role
        </Text>
      </Box>
      {showActionColumn && (
        <Box flex={1.28} alignItems='center' justifyContent='center'>
          <Text variant='webBodySecondary' color='grey04'>
            Action
          </Text>
        </Box>
      )}
    </Box>
  );
};
